export const DEFAULT_THRESHOLD = 400;

export function shouldShow(scrollY, threshold) {
  return scrollY >= threshold;
}

export function getScrollBehavior(prefersReducedMotion) {
  return prefersReducedMotion ? 'auto' : 'smooth';
}

export function setupBackToTop({ threshold = DEFAULT_THRESHOLD, root = document } = {}) {
  const button = root.querySelector('[data-kf-back-to-top]');
  if (!button) return null;

  let ticking = false;
  let hideTimer = null;

  function updateVisibility() {
    if (shouldShow(window.scrollY, threshold)) {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      button.hidden = false;
      requestAnimationFrame(() => button.classList.add('is-visible'));
    } else {
      button.classList.remove('is-visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        button.hidden = true;
        hideTimer = null;
      }, 220);
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateVisibility();
      ticking = false;
    });
  }

  function onClick() {
    const prefers = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: getScrollBehavior(prefers) });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  button.addEventListener('click', onClick);
  updateVisibility();

  return {
    updateVisibility,
    destroy() {
      window.removeEventListener('scroll', onScroll);
      button.removeEventListener('click', onClick);
      if (hideTimer) clearTimeout(hideTimer);
    },
  };
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupBackToTop());
  } else {
    setupBackToTop();
  }
}
